import axios from 'axios';
import ENV from 'env';
import { logout } from 'store/reducers/auth';

const intance = axios.create({
  timeout: 60000,
});

var promiseRefresh = null;

const urlNotAccessToken = [
  '/login',
  '/refresh-token',
  '/register',
  '/verify-2fa-token',
  '/register-verify',
  '/sub-account/register',
  '/password/forgot',
  '/password/reset',
  '/oauth-google'
];

intance.interceptors.request.use((request) => {
  if (!urlNotAccessToken.includes(request?.url)) {
    const accessToken = localStorage.getItem('accessToken');
    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }

  return request;
});

const refreshTokenApi = (body) => {
  return intance.post('/refresh-token', body, {
    baseURL: ENV.AUTH_BASE_URL,
  });
};

export const configInterceptor = (store) => {
  intance.interceptors.response.use(
    (response) => {
      if (response.headers['content-type'] !== 'application/json') {
        let filename = '';
        let disposition = response.headers['content-disposition'];

        if (disposition && disposition.indexOf('attachment') !== -1) {
          let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          let matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }

        if (filename.endsWith('.csv')) {
          const url = window.URL.createObjectURL(response.data);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }

      return {
        data: response?.data,
        status: response.status,
      };
    },
    async (error) => {
      const { response, config } = error;
      const originalRequest = config;
      const refreshToken = localStorage.getItem('refreshToken');

      if (
        response.status === 401 &&
        !originalRequest._retry &&
        originalRequest.url !== '/refresh-token' &&
        refreshToken
      ) {
        originalRequest._retry = true;
        if (!promiseRefresh) {
          promiseRefresh = new Promise(async (resolve, reject) => {
            const res = await refreshTokenApi({ refreshToken });
            if (res.status === 200) {
              const { accessToken, refreshToken, expirationTime } = res.data;
              localStorage.setItem('accessToken', accessToken);
              localStorage.setItem('refreshToken', refreshToken);
              localStorage.setItem('expirationTime', expirationTime);
              resolve(res);
            } else {
              localStorage.clear();
              store.dispatch(logout());
              reject(res);
            }
          });
        }

        try {
          const { status, data } = await promiseRefresh;
          if (status === 200) {
            originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
            return intance(originalRequest);
          }
        } catch {
        } finally {
          promiseRefresh = null;
          originalRequest._retry = false;
        }
      }

      return {
        data: response.data,
        ...response.data,
        status: response.status,
      };
    }
  );
};

const authApi = {};

authApi.get = (url, config = {}) => {
  return intance.get(url, { ...config, baseURL: ENV.AUTH_BASE_URL });
};

authApi.post = (url, data, config = {}) => {
  return intance.post(url, data, {
    ...config,
    baseURL: ENV.AUTH_BASE_URL,
  });
};

authApi.delete = (url, config = {}) => {
  return intance.delete(url, { ...config, baseURL: ENV.AUTH_BASE_URL });
};

authApi.put = (url, data, config = {}) => {
  return intance.put(url, data, {
    ...config,
    baseURL: ENV.AUTH_BASE_URL,
  });
};

const coreApi = {};

coreApi.get = (url, config = {}) => {
  return intance.get(url, { ...config, baseURL: ENV.CORE_BASE_URL });
};

coreApi.post = (url, data, config = {}) => {
  return intance.post(url, data, {
    ...config,
    baseURL: ENV.CORE_BASE_URL,
  });
};

coreApi.delete = (url, config = {}) => {
  return intance.delete(url, { ...config, baseURL: ENV.CORE_BASE_URL });
};

coreApi.put = (url, data, config = {}) => {
  return intance.put(url, data, {
    ...config,
    baseURL: ENV.CORE_BASE_URL,
  });
};

const storageApi = {};

storageApi.get = (url, config = {}) => {
  return intance.get(url, { ...config, baseURL: ENV.STORAGE_BASE_URL });
};

storageApi.post = (url, data, config = {}) => {
  return intance.post(url, data, {
    ...config,
    baseURL: ENV.STORAGE_BASE_URL,
  });
};

storageApi.delete = (url, config = {}) => {
  return intance.delete(url, {
    ...config,
    baseURL: ENV.STORAGE_BASE_URL,
  });
};

storageApi.put = (url, data, config = {}) => {
  return intance.put(url, data, {
    ...config,
    baseURL: ENV.STORAGE_BASE_URL,
  });
};

const exp = {
  authApi,
  coreApi,
  storageApi,
};

export default exp;
